export default __webpack_public_path__ + "20ab8451606585c4729edb962c16b4e2.png";